/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */

// React
import React from "react";

// MuI
import { Box, TextField, IconButton, Paper } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

/* ---------------------------------------------------------------------
 *                             ChatInput Component
 * --------------------------------------------------------------------- */

/**
 * 定义聊天输入框组件
 * @param {string}  message - 输入的消息
 * @param {function} onMessageInput  - 处理输入的消息
 * @param {function} onSendMessage - 处理发送消息
 * @function ChatInput
 * @returns 聊天输入框
 */
export default function ChatInput({ message, onMessageInput, onSendMessage }) {
  /* ---------------------------------------------------------------------
   *                            Event Handlers
   * --------------------------------------------------------------------- */

  /**
   * 处理键盘事件
   * @param {KeyboardEvent} event - 键盘事件对象
   */
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      onSendMessage();
    }
  };

  /* ---------------------------------------------------------------------
   *                            Render Component
   * --------------------------------------------------------------------- */

  return (
    <Box
      sx={{
        width: "100%",
        padding: "10px",
        boxSizing: "border-box",
        background: "transparent",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          position: "relative",
          border: "1px solid #bdbdbd",
          borderRadius: "8px",
          background: "#fff",
        }}
      >
        {/* 输入框 */}
        <TextField
          fullWidth
          multiline
          minRows={2}
          maxRows={5}
          variant="standard"
          value={message}
          onChange={onMessageInput}
          onKeyDown={handleKeyDown}
          placeholder="请输入"
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "18px",
              padding: "16px 60px 40px 8px",
              background: "transparent",
            },
          }}
        />

        <Box
          sx={{
            position: "absolute",
            right: 12,
            bottom: 8,
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* 附件按钮 */}
          <IconButton size="small">
            <AttachFileIcon fontSize="small" />
          </IconButton>

          {/* 发送按钮 */}
          <IconButton
            size="small"
            onClick={onSendMessage}
            sx={{
              marginLeft: "2px",
            }}
          >
            <ArrowUpwardIcon />
          </IconButton>
        </Box>
      </Paper>
    </Box>
  );
}
